// Helper function to render paragraphs with consistent formatting
// Helper function to format text with asterisks as bold
export const formatTextWithBold = (text) => {
  if (!text) return text;
  
  // Regular expression to match text between asterisks
  const boldRegex = /\*(.*?)\*/g;
  
  // Replace matched text with bold elements
  return text.split(boldRegex).map((part, index) => {
    // Even indices are regular text, odd indices are bold text
    if (index % 2 === 0) {
      return part;
    } else {
      return <strong key={`bold-${index}`}>{part}</strong>;
    }
  });
};

export const renderParagraphs = (paragraphs) => {
  if (!paragraphs) return null;
  
  return paragraphs.map((paragraph, index) => {
    // Check if this is a bullet point (starts with "-")
    if (paragraph.trim().startsWith("-")) {
      return (
        <p key={index} className="ml-4 mb-1 flex">
          <span className="inline-block mr-2 text-[#333333] dark:text-[#4f9cf9] font-bold leading-normal">•</span>
          <span className="flex-1">{formatTextWithBold(paragraph.trim().substring(1).trim())}</span>
        </p>
      );
    } 
    // Check if this is an empty paragraph or space-only for spacing
    else if (paragraph.trim() === "" || paragraph.trim() === " ") {
      return <div key={index} className="h-4"></div>;
    } 
    // Regular paragraph
    else {
      return <p key={index} className="mb-2">{formatTextWithBold(paragraph)}</p>;
    }
  });
}; 